export default from './PreferredBankers';



// WEBPACK FOOTER //
// ./src/containers/PreferredBankers/index.js